import React, { useEffect, useState } from 'react'
import TextFieldUniversal from '../../../../../../validate/form/text/TextFieldUniversal'

const DeliveryTtnField = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState('')

  return (
	<TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'ТТН'} 
        placeholder={'Введіть номер ТТН'}
        validates={{
            isEmpty: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
    />
  )
}

export default DeliveryTtnField